module.exports = __webpack_public_path__ + "static/media/reddit-icon.7ec07896.svg";